module.exports = __webpack_public_path__ + "3bac0b0885d8b01f918ff31b7600c4a2.svg";